import { Box, CircularProgress, Dialog, Typography } from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./LoadingDialog.css";

const SPINNER_GREEN = "#A2C357";

function LoadingDialog({ open, message }) {
  const { t, activeLanguage } = useTranslationSetup();

  return (
    <Dialog
      open={open}
      className="loading-dialog"
      maxWidth={false}
      PaperProps={{ className: "loading-dialog-paper" }}
    >
      <Box className="loading-dialog-content">
        <Box className="loading-dialog-spinner-wrap">
          <CircularProgress
            size={44}
            thickness={4.5}
            sx={{
              color: SPINNER_GREEN,
            }}
          />
        </Box>
        <Typography className="loading-dialog-text" lang={activeLanguage}>
          {message || t("checking_quality")}
        </Typography>
      </Box>
    </Dialog>
  );
}

export default LoadingDialog;
